import { render, staticRenderFns } from "./bibtex_input.vue?vue&type=template&id=3eab62a0&scoped=true"
import script from "./bibtex_input.vue?vue&type=script&lang=js"
export * from "./bibtex_input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eab62a0",
  null
  
)

export default component.exports